import React, { PureComponent } from "react";
import { Query } from "react-apollo";
import gql from "graphql-tag";

import getGraphqlURI from "utils/getGraphqlURI";

const parseData = (data) => ({
  ...data,
  seo: JSON.parse(data.seo),
});

export default (
    getSlugFromProps,
    getPostType,
    getLocale = (props) => props.match.params.language,
    renderNotFound = () => <h1>Not found</h1>
  ) =>
  (WrappedComponent) =>
    class WithPost extends PureComponent {
      render() {
        const slug = getSlugFromProps(this.props);
        const endpoint = getPostType(this.props);
        const locale = getLocale(this.props);

        return (
          <Query
            context={{
              uri: getGraphqlURI(locale),
            }}
            fetchPolicy="cache-and-network"
            query={gql`
            {
              ${endpoint}By(uri: "${slug}"){
                title
                seo
                status
                slug
                modules {
                  ...on Modules__bodyText {
                    layout
                    bgcolor
                    body
                    lines
                    truncate
                    buttons {
                      text
                      layout
                      type
                      externalLink
                      internalLink {
                        ...on Page {
                          link
                        }
                        ...on Case{
                          link
                        }
                        ...on Product{
                          link
                        }
                      }
                    }
                  }

                  ...on Modules__bodyTextColumns {
                    layout
                    bgcolor
                    firstColumn
                    secondColumn
                    buttons {
                      text
                      layout
                      type
                      externalLink
                      internalLink {
                        ...on Page {
                          link
                        }
                        ...on Case{
                          link
                        }
                      }
                    }
                  }

                  ...on Modules__distance {
                    layout
                    distance
                    bgcolor
                  }

                  ...on Modules__documentList {
                    layout
                    heading
                    documents {
                      document {
                        title
                        documentType
                        language
                        file {
                          sourceUrl
                        }
                      }
                    }
                    documentTypes {
                      slug
                      title
                    }
                    languages {
                      slug
                      title
                    }
                  }


                  ...on Modules__productPage {
                    layout
                    title
                    bodyText
                    advantagesText
                    certificates{
                      sourceUrl
                    }
                    pictures {
                      image {
                        sourceUrl
                      }
                    }
                    advantages {
                      advantage_icon
                    }
                    urls{
                      urlTechnical{
                        ...on Page{
                          link
                        }
                        ...on Product{
                          link
                        }
                      }
                      urlLocate {
                        ...on Page{
                          link
                        }
                        ...on Product{
                          link
                        }
                      }
                      urlWhere{
                        ...on Page{
                          link
                        }
                        ...on Product{
                          link
                        }
                      }
                    }
                  }

                  ...on Modules__documentSearch {
                    layout
                    showAllDocuments
                    heading
                    documentTypes {
                      slug
                      title
                    }
                    languages {
                      slug
                      title
                    }
                    products {
                      slug
                      title
                    }
                    
                  }

                  ...on Modules__download {
                    layout
                    title
                    description
                    file {
                      sourceUrl
                    }
                  }

                  ...on Modules__featuredLinks {
                    layout
                    title
                    links {
                      text
                      link
                      image {
                        sourceUrl
                      }
                    }
                  }

                  ...on  Modules__gallery {
                    layout
                    items {
                      image {
                        sourceUrl
                      }
                      hasVideo
                      video
                      text
                    }
                  }

                  ...on Modules__header {
                    layout
                    cta
                    title
                    image {
                      sourceUrl
                    }
                  }

                  ...on Modules__headerText {
                    layout
                    cta
                    title
                    description
                  }

                  ...on Modules__headerVideo {
                    layout
                    cta
                    title
                    video {
                      sourceUrl
                    }
                  }

                  ...on Modules__hero {
                    layout
                    title
                    heading
                    button1 {
                      target
                      url
                      title
                    }
                    button2 {
                      target
                      url
                      title
                    }
                    video {
                      sourceUrl
                    }
                    videoMobile {
                      sourceUrl
                    }
                    image {
                      sourceUrl
                    }
                    featured {
                      type
                      product {
                        title
                        link
                        image {
                          sourceUrl
                        }
                        video {
                          sourceUrl
                        }
                      }
                      heading
                      paragraph
                      externalLink
                      link {
                        url
                      }
                    }
                  }

                  ...on Modules__highlight {
                    layout
                    highlightSize
                    posX
                    posY
                    heading
                    text
                    image {
                      sourceUrl
                    }
                  }

                  ...on Modules__imageAndText {
                    layout
                    header
                    body
                    buttons {
                      text
                      layout
                      type
                      externalLink
                      internalLink {
                        ...on Page {
                          link
                        }
                        ...on Case {
                          link
                        }
                      }
                    }
                    image {
                      sourceUrl
                      altText
                    }
                    orientation
                  }

                  ...on Modules__fixedImageAndText {
                    layout
                    bgcolor
                    header
                    body
                    buttons {
                      text
                      layout
                      type
                      externalLink
                      internalLink {
                        ...on Page {
                          link
                        }
                        ...on Case {
                          link
                        }
                      }
                    }
                    image {
                      sourceUrl
                      altText
                    }
                    orientation
                    youtube
                    video {
                      sourceUrl
                    }
                  }

                  ...on Modules__leadIn {
                    layout
                    text
                  }

                  ...on Modules__locations {
                    layout
                    bgcolor
                    title
                  }

                  ...on Modules__newsletter {
                    layout
                    embed
                    showScroll
                    scrollButtonText
                  }

                  ...on Modules__products {
                    layout
                    text
                  }

                  ...on Modules__productsNew{
                    layout
                    text
                    urlManagement
                    urlClimate
                    urlCapacitive
                    hide_management
                  }

                  ...on Modules__quote {
                    layout
                    quote
                    name
                    company
                  }

                  ...on Modules__faq {
                    layout
                    heading
                    items {
                      title
                      text
                      img {
                        sourceUrl
                      }
                    }
                  }

                  ...on Modules__downloads {
                    layout
                    bgcolor
                    label
                    mod_title
                    custom_document {
                      document {
                        document_title
                        document_type
                        source_url
                        document_slug
                        document_language
                        product_id {
                          key
                        }
                        custom_product_id
                      }
                    }
                    documents {
                      language
                      title
                      product
                      documentType
                      slug
                      title
                      file {
                        sourceUrl
                        slug
                      }
                    }
                    documentTypes {
                      slug
                      title
                    }
                    languages {
                      slug
                      title
                    }
                    products {
                      slug
                      title
                    }
                  }

                  ...on Modules__twoColumnText {
                    layout
                    title
                    firstColumn
                    secondColumn
                  }

                  ...on Modules__productLandingHero {
                    layout
                    title
                    buttonText
                    buttonLink
                    backgroundImage {
                      sourceUrl
                    }
                    backgroundVideo {
                      sourceUrl
                    }
                    backgroundVideoMobile {
                      sourceUrl
                    }
                  }

                  ...on Modules__landingPageHero {
                    layout
                    title
                    text
                    overlay{
                      bg_color
                      opacity
                    }
                    form_bg{
                      bg_color
                      opacity
                    }
                    text_color
                    backgroundImage {
                      sourceUrl
                    }
                    embed
                  }

                  ...on Modules__landingPageColumns {
                    layout
                    columnLeft
                    columnRight
                    youtubeId
                    titleLeft
                    titleRight
                  }

                  ...on Modules__callout {
                    layout
                    text
                  }

                  ...on Modules__productLandingGallery {
                    layout
                    images {
                      title
                      description
                      image {
                        sourceUrl
                      }
                      imageMobile {
                        sourceUrl
                      }
                      link
                    }
                  }

                  ...on Modules__productLandingVideo {
                    layout
                    alignment
                    backgroundColor
                    title
                    description
                    buttonText
                    buttonLink
                    video {
                      sourceUrl
                    }
                    videoMobile {
                      sourceUrl
                    }
                  }

                  ...on Modules__focus {
                    layout
                    title
                    text
                    buttonText
                    buttonLink
                    youtube
                    image {
                      sourceUrl
                    }
                    video {
                      sourceUrl
                    }
                    videoMobile {
                      sourceUrl
                    }
                  }

                  ...on Modules__appShowcase {
                    layout
                    title
                    firstColumn
                    secondColumn
                    image {
                      sourceUrl
                    }
                    iosLink
                    androidLink
                  }

                  ...on Modules__videoPlaylistYouTube {
                    layout
                    videos {
                      title
                      description
                      linkText
                      linkUrl
                      youtubeVideo
                    }
                  }

                  ...on Modules__videoPlaylist {
                    layout
                    videos {
                      title
                      description
                      linkText
                      linkUrl
                      video {
                        sourceUrl
                      }
                    }
                  }

                  ...on Modules__map {
                    layout
                  }

                  ...on Modules__tryBeforeYouBuy {
                    layout
                    steps {
                      title
                      type
                      image {
                        sourceUrl
                      }
                      appleLink
                      googleLink
                      subTitle
                      text
                    }
                  }

                  ...on Modules__scrollAnchor {
                    layout
                    moduleId
                  }

                  ...on Modules__leds{
                    layout
                    header
                    buttons {
                      text
                      layout
                      type
                      externalLink
                      internalLink {
                        ...on Page {
                          link
                        }
                        ...on Case {
                          link
                        }
                      }
                    }
                    image {
                      sourceUrl
                      altText
                    }
                    orientation
                  }

                  ...on Modules__pressMaterials {
                    layout
                    showAllMaterials
                    heading
                    products {
                      slug
                      title
                    }
                    categories {
                      slug
                      title
                    }
                  }

                  ...on Modules__contact_salesmen { 
                    layout
                    bgcolor
                    textfield
                    salesperson {
                      image {
                        sourceUrl
                      }
                      contact_info{
                        ext
                        mobile
                        email
                      }
                      name
                      subtitle
                      linkedin_url
                    }
                  }

                  ...on Modules__contact_menu{
                    layout
                    item {
                      text
                      url {
                        link
                      }
                    }
                  }

                  ...on Modules__contact_form{
                    layout,
                    embed,
                    address, 
                    display,
                    justify
                  }

                  ...on Modules__youtubeVideo {
                    layout
                    bgcolor
                    videos {
                      id
                    }
                  }


                  ...on Modules__gatekeeper{
                    layout
                    bodyText
                    id
                  }

                  ...on Modules__key{
                    layout
                    id
                    bodyText
                  }

                  ...on Modules__contact_video{
                    bgcolor
                    layout
                    videoId
                    img_vid
                    text
                    side
                    fit
                    image {
                      sourceUrl
                    }
                  }

                  ...on Modules__button{
                    layout
                    customButton{
                      width
                      height
                      text
                      text_translation
                      color
                      position
                      url
                    }
                  }
                  ...on Modules__some_buttons{
                    layout
                    bgcolor
                    fb
                    linked_in
                    yt
                    twitter
                    justify
                    header
                  }
                  ...on Modules__industry_hero{
                    layout
                    title
                    image {
                      sourceUrl
                    }
                  }
                  ...on Modules__industry_products{
                    layout
                    bgcolor
                    heading
                    featured{
                      sensor_name
                      product {
                        title
                        link
                        image {
                          sourceUrl
                        }
                        video {
                          sourceUrl
                        }
                      }
                    }
                  }
                  ...on Modules__categories_buttons{
                    layout
                    heading
                    bgcolor
                    button {
                      text
                      link_to {
                        link
                      }
                      image {
                        sourceUrl
                      }
                    }
                  }
                  ...on Modules__sensor_buttons{
                    layout
                    bgcolor
                    button {
                      text
                      link_to {
                        link
                      }
                      image {
                        sourceUrl
                      }
                    }
                  }
                ...on Modules__dealer_selector{
                  layout
                  bgcolor
                  dealer_title
                  dealer_title_translation
                  show_salesman
                  select_dealer {
                    alternative_url{
                      alt_url
                      display_url
                    }
                    dealer_selector
                    dealer_image {
                      sourceUrl
                    }
                  }
                  salesman {
                    salesman_name
                    title
                    translation
                    phone_external
                    phone_mobile
                    email
                    connect
                    linkedin_link
                  }
                } 
                ...on Modules__jpn_hero{
                  layout
                  pictures {
                    image {
                      sourceUrl
                    }
                    top_text
                    bottom_text_jpn
                    bottom_text_eng
                    button_text_japanese
                    button_text_english
                    url{
                      ...on Page{
                        link
                      }
                      ...on Product{
                        link
                      }
                    }
                  }
                }
                ...on Modules__jpn_product_front{
                  layout
                  title_product{
                    show_title
                    title_japanese
                    title_english
                  }
                  bgcolor
                  products {
                    description
                    description_eng
                    custom_image{
                      sourceUrl
                    }
                    product {
                      slug
                      link
                      title
                      image {
                        sourceUrl
                      }
                    }
                    button {
                      button_text
                      button_translation
                    }
                    tag_text
                  }
                }
                ...on Modules__jpn_categories{
                  layout
                  category_button{
                    title
                    subtitle
                    image{
                      sourceUrl
                    }
                    url{
                      ...on Page{
                        link
                      }
                      ...on Product{
                        link
                      }
                    }
                  }
                }
                ...on Modules__jpn_icon_button{
                  layout
                  bgcolor
                  icons{
                    text
                    text_translation
                    icon{
                      sourceUrl
                    }
                    url{
                      ...on Page{
                        link
                      }
                      ...on Product{
                        link
                      }
                    }
                  }
                }
                ...on Modules__technical_info_table{
                  layout
                  bgcolor
                  table {
                    label {
                      label_main
                      label_translation
                    }
                    value {
                      value_main
                      value_translation
                    }
                  }
                  table_header {
                    header_value
                    header_translation
                  }
                }
                }
              }
            }`}
          >
            {({ loading, error, data }) => (
              <div>
                {!error && (data[`${endpoint}By`] || loading) && (
                  <WrappedComponent
                    {...this.props}
                    loading={loading}
                    post={
                      data[`${endpoint}By`] && parseData(data[`${endpoint}By`])
                    }
                  />
                )}
                {(error || (!loading && !data[`${endpoint}By`])) &&
                  renderNotFound()}
              </div>
            )}
          </Query>
        );
      }
    };



// WEBPACK FOOTER //
// ./src/containers/withPost.js